module.exports = __webpack_public_path__ + "img/ni.6895c3dc.svg";